import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UserRolesAndPermissionsService } from '@core/services/user-roles-and-permissions.service';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs';
import { DvTabLink, DvTabsComponent } from '@devinco/ui/dds';
import { TripRouteName } from '@pages/trips-page/trips-page.module';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-trip-tabs',
  templateUrl: './trip-tabs.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DvTabsComponent, RouterOutlet],
})
export class TripTabsComponent implements OnInit {
  private translate = inject(TranslateService);
  private rolesService = inject(UserRolesAndPermissionsService);

  tabLinks: DvTabLink[];

  ngOnInit(): void {
    this.toggleTabVisibility();
  }

  private toggleTabVisibility(): void {
    this.tabLinks = [
      {
        label: this.translate.instant('Trips.Tabs.Information'),
        link: TripRouteName.Information,
        id: TripRouteName.Information,
      },
      {
        label: this.translate.instant('Trips.Tabs.Expenses'),
        link: TripRouteName.Expenses,
        id: TripRouteName.Expenses,
      },
      {
        label: this.translate.instant('Trips.Tabs.OnMap'),
        link: TripRouteName.OnMap,
        id: TripRouteName.OnMap,
      },
      {
        label: this.translate.instant('Trips.Tabs.MergeTrip'),
        link: TripRouteName.MergeTrip,
        id: TripRouteName.MergeTrip,
      },
    ];

    this.rolesService
      .getUserRolesAndPermissions()
      .pipe(take(1))
      .subscribe(rolesAndPerm => {
        if (
          !rolesAndPerm.Permissions.includes(RolesAndPermissions.TripShowInMap)
        ) {
          this.tabLinks = this.tabLinks.map(tab => ({
            ...tab,
            hide: tab.link === 'on-map',
          }));
        }
      });
  }
}
